<template>
    <!-- gnb -->
    <div class="pagination">
        <a v-if="pageObj.sPage > pageParam.pageCnt"  class="page-first" @click="page(1)"
            ><span class="blind">처음</span></a
        >
        <a
            v-if="pageObj.sPage > pageParam.pageCnt"
            
            class="page-prev"
            @click="page(pageObj.sPage - pageParam.pageCnt)"
            ><span class="blind">이전</span></a
        >
        <a
            v-for="index in pageObj.sPage + pageParam.pageCnt"
            v-if="index >= pageObj.sPage && index <= pageObj.tPage"
            
            class="page-num"
            :class="index == pageParam.curPage ? 'on' : ''"
            @click="page(index)"
            ><span>{{ index }}</span></a
        >
        <a
            v-if="pageObj.sPage <= pageObj.tPage - pageParam.pageCnt"
            
            class="page-next"
            @click="page(pageObj.sPage + pageParam.pageCnt)"
            ><span class="blind">다음</span></a
        >
        <a
            v-if="pageObj.sPage <= pageObj.tPage - pageParam.pageCnt"
            
            class="page-last"
            @click="page(pageObj.tPage)"
            ><span class="blind">마지막</span></a
        >
    </div>
</template>
<!-- // gnb -->
<script>
import { mapActions, mapState } from 'vuex';
import {
    JWT_TOKEN,
    JWT_REFRESH_TOKEN,
    MEMBER_ID,
    NAME,
    AUTO_YN,
    CONSTRUCTION_NM,
    CONSTRUCTION,
    TYPE
} from '../../const';
export default {
    name: 'Pagination',
    components: {},
    props: {
        pageParam: {
            type: Object
        }
    },
    data: () => {
        return {
            constructionNm: '',
            name: '',
            pageObj: {
                sPage: 0,
                tPage: 0
            }
        };
    },
    watch: {
        pageParam: {
            // the callback will be called immediately after the start of the observation
            immediate: true,
            deep: true,
            handler(val) {
                this.pageParam = val;
                this.pageObj.sPage =
                    Math.ceil(this.pageParam.curPage / this.pageParam.pageCnt) * this.pageParam.pageCnt -
                    (this.pageParam.pageCnt - 1);
                this.pageObj.tPage = Math.ceil(this.pageParam.totalCnt / this.pageParam.lstCnt);
            }
        }
    },
    computed: {
        ...mapState({})
    },
    beforeCreate() {},
    created() {},
    mounted() {
        // this.pageObj.sPage = Math.ceil(this.pageParam.curPage / this.pageParam.pageCnt) * this.pageParam.pageCnt - (this.pageParam.pageCnt - 1);
        // this.pageObj.tPage = Math.ceil(this.pageParam.totalCnt / this.pageParam.lstCnt);
        //
        // console.log("this.pageParam:::",this.pageParam)
        // console.log("this.sPage:::",this.pageObj.sPage)
        // console.log("this.tPage:::",this.pageObj.tPage )
        // console.log("this.totalCnt:::",this.pageParam.totalCnt )
        // console.log("this.lstCnt:::",this.pageParam.lstCnt )
    },
    beforeDestroy() {},
    methods: {
        ...mapActions(['showLoading', 'hideLoading']),
        page(page) {
            this.$emit('pageCallback', page);
        }
    }
};
</script>
